export const changePasswordFormData = () => {
    return [
        {
            id  : "old_password",
            label: "Old Password",
            fields: [
                {
                    type: "password",
                    placeholder: "Masukan Password Lama..."
                }
            ]
        },
        {
            id      : "new_password",
            label   : "New Password",
            fields  : [{
                type : "password",
                placeholder : "Masukan Password Baru..."
            }]
        },
        {
            id      : "new_password_confirmation",
            label   : "Re-Type New Password",
            fields  : [{
                type    : "password",
                placeholder: "Ketik Ulang Password Baru..."
            }]
        }
    ]
}